import { editCancelReturnRequestDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const geteditCancelReturnRequestEn = () => {
  const data = editCancelReturnRequestDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addeditCancelReturnRequest = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-edit-or-cancel-an-empty-and-return-request`,
    ) &&
    document.getElementById(`editCancelReturnRequestJSONLD`) === null
  ) {
    const script = editCancelReturnRequestJSONLDEn()
    addJSONLDToHead(script, `editCancelReturnRequestJSONLD`)
  } else {
    removeElement(`editCancelReturnRequestJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const editCancelReturnRequestJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: geteditCancelReturnRequestEn(),
  }
  return FaqBagsterTemplate
}
